import { ChevronRight, LogOut } from 'lucide-react';
import { useOrganization } from '../contexts/OrganizationContext';
import { signOut } from '../lib/supabase';

const TYPE_LABEL = {
  club: 'Club',
  academy: 'Academia',
  league: 'Liga',
  tournament_organizer: 'Organizador de torneos',
  federation: 'Federación',
};

// Pantalla de seleccion de organizacion (aislamiento duro: una a la vez).
// Solo se muestra cuando el usuario pertenece a 2+ orgs y aun no eligio en esta
// sesion. Al elegir, switchOrg fija la org activa (header x-active-org) y entra.
export default function OrgSelector() {
  const { myOrgs, switchOrg } = useOrganization();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-4 py-10">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <img
            src="/assets/myklubb-icon.svg"
            alt="MYKLUBB"
            className="mx-auto mb-5 size-10"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
          <h1 className="text-2xl font-bold tracking-tight">Elige tu organización</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Gestionas una organización a la vez.
          </p>
        </div>

        <div className="grid gap-2.5">
          {myOrgs.map((o) => {
            const name = o.name || o.short_name || 'Organización';
            const iconBg = o.color_icon_background || '#0D0D0D';
            const logo = o.logo_url || '/assets/myklubb-icon.svg';
            const label = TYPE_LABEL[o.type] || o.type;
            return (
              <button
                key={o.org_id}
                onClick={() => switchOrg(o.org_id)}
                className="group flex items-center gap-3 rounded-xl border border-border bg-card p-3.5 text-left transition-colors hover:bg-accent"
              >
                <div
                  className="flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-lg"
                  style={{ backgroundColor: iconBg }}
                >
                  <img
                    src={logo}
                    alt={name}
                    className="size-5 object-contain"
                    onError={(e) => { e.target.src = '/assets/myklubb-icon.svg'; }}
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="truncate font-semibold leading-tight">{name}</div>
                  <div className="mt-0.5 text-xs uppercase tracking-wide text-muted-foreground">
                    {label}
                  </div>
                </div>
                <ChevronRight className="size-5 shrink-0 text-muted-foreground transition-transform group-hover:translate-x-0.5" />
              </button>
            );
          })}
        </div>

        <button
          onClick={() => signOut()}
          className="mx-auto mt-8 flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground"
        >
          <LogOut className="size-4" />
          Cerrar sesión
        </button>
      </div>
    </div>
  );
}
